// utils.js
export const googleData = async (accessToken) => {
    const endpoint = 'https://www.googleapis.com/oauth2/v3/userinfo';
    const response = await fetch(endpoint, {
        headers: {
            Authorization: `Bearer ${accessToken}`
        }
    });
    if (!response.ok) {
        throw new Error('Failed to fetch user info');
    }
    const data = await response.json();
    return data;
};
export function calculateWordFrequency(text) {
    const words = text.toLowerCase().match(/\w+/g);
    if (!words)
        return {};
    const frequency = {};
    words.forEach(word => {
        frequency[word] = (frequency[word] || 0) + 1;
    });
    return frequency;
}
export function trackButtonClick(buttonName, val) {
    if (typeof gtag !== 'undefined') {
        gtag('event', 'button_click', {
            event_category: 'interaction',
            event_label: buttonName,
            event_value: val,
        });
    }
}
export function trackPurchaseInitiated(type, val) {
    if (typeof gtag !== 'undefined') {
        gtag('event', 'purchase_initiated', {
            event_category: 'purchase',
            event_label: type + ' purchase initiated',
            event_value: val,
        });
    }
}
export function trackPurchaseCompleted(type, val) {
    if (typeof gtag !== 'undefined') {
        gtag('event', 'purchase_completed', {
            event_category: 'purchase',
            event_label: type + ' purchase completed',
            event_value: val,
        });
    }
}
